export default __webpack_public_path__ + "static/media/eth.4aa4d7e0.png";